import { Center, Text } from '@landr/maestro';

export const EmptyState = () => {
  return (
    <Center>
      <Text>Nothing found</Text>
    </Center>
  );
};
